
import { defineComponent, ref } from 'vue';

export default defineComponent({
    setup() {
        const games = ref([
            {
                key: 'klondike1',
                title: 'Klondike',
                subTitle: '',
                path: '/klondike',
                image: '/img/thumb/klondike.png',
                bgColor: 'rgb(149, 33, 117)',
                imgBgColor: 'rgb(195, 78, 221)',
            },
            {
                key: 'freeCell',
                title: 'FreeCell',
                subTitle: '',
                path: '/freecell',
                image: '/img/thumb/freecell.png',
                bgColor: '#bf360c',
                imgBgColor: '#ff8a65',
            },
            {
                key: 'spider',
                title: 'Spider',
                subTitle: '',
                path: '/spider',
                image: '/img/thumb/spider.png',
                bgColor: '#37474F',
                imgBgColor: '#90A4AE',
            },
            {
                key: 'tripeaks',
                title: 'Tri Peaks',
                subTitle: '',
                path: '/tripeaks',
                image: '/img/thumb/tripeak.png',
                bgColor: '#004D40',
                imgBgColor: '#26A69A',
            },
            {
                key: 'sudoku',
                title: 'Sudoku',
                subTitle: '',
                path: '/sudoku',
                image: '/img/thumb/sudoku.png',
                bgColor: '#4e342e',
                imgBgColor: '#bcaaa4',
            },
            {
                key: 'pyramid',
                title: 'Pyramid',
                subTitle: '',
                path: '/pyramid',
                image: '/img/thumb/pyramid.png',
                bgColor: '#22543D',
                imgBgColor: '#48BB78',
            },
            {
                key: 'minesweeper',
                title: 'Minesweeper',
                subTitle: '',
                path: '/minesweeper',
                image: '/img/thumb/mine.png',
                bgColor: '#742A2A',
                imgBgColor: '#FC8181',
            },
            {
                key: 'yukon',
                title: 'Yukon',
                subTitle: '',
                path: '/yukon',
                image: '/img/thumb/klondike.png',
                bgColor: '#311B92',
                imgBgColor: '#7E57C2',
            },
            {
                key: 'forty',
                title: 'Forty Thieves',
                subTitle: '',
                path: '/forty-thieves',
                image: '/img/thumb/forty.png',
                bgColor: '#1B5E20',
                imgBgColor: '#7CB342',
            },
            {
                key: 'scorpion',
                title: 'Scorpion',
                subTitle: '',
                path: '/scorpion',
                image: '/img/thumb/scorpion.png',
                bgColor: '#D84315',
                imgBgColor: '#FFAB91',
            },
            {
                key: 'canfield',
                title: 'Canfield',
                subTitle: '',
                path: '/canfield',
                image: '/img/thumb/klondike.png',
                bgColor: '#6A1B9A',
                imgBgColor: '#CE93D8',
            },
            {
                key: 'golf',
                title: 'Golf',
                subTitle: '',
                path: '/golf',
                image: '/img/thumb/golf.png',
                bgColor: '#78350F',
                imgBgColor: '#D97706',
            },
        ]);

        return {
            games,
        };
    },
});
